import React from "react";

export default class ProductList extends React.Component {
  render() {
    return <div>list</div>;
  }
}
